import React from 'react';

const OrderedList = ({ stroke, ...props }) => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.8125 9H15.6875" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.8125 4.5H15.6875" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.8125 13.5H15.6875" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M3.3125 4.21875L4.4375 3.65625V7.59375"
      fill="none"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="none"
      d="M3.38984 10.7297C3.44168 10.6014 3.51999 10.4854 3.61968 10.3894C3.71938 10.2933 3.8382 10.2194 3.96839 10.1724C4.09859 10.1254 4.23723 10.1064 4.37527 10.1166C4.51331 10.1269 4.64764 10.1661 4.7695 10.2317C4.89135 10.2974 4.99799 10.388 5.08246 10.4977C5.16692 10.6073 5.22731 10.7336 5.25968 10.8681C5.29204 11.0027 5.29567 11.1426 5.27031 11.2787C5.24495 11.4148 5.19117 11.544 5.1125 11.6578L3.3125 14.0625H5.28125"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default OrderedList;
